import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
/* empty css                  */
import { useId } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/ChangeSummary/ChangeSummary.tsx
/**
* What an import will change, one line each, before it's applied (Import org
* structure, step 2). Warning lines are highlighted with an icon.
*/
function ChangeSummary({ items, emptyLabel = "No changes", "aria-label": ariaLabel = "Summary of changes", className, ...rest }) {
	const shown = items.filter((item) => item.count !== 0);
	if (shown.length === 0) return /* @__PURE__ */ jsx("p", {
		className: cx("ds-change-summary__empty", className),
		children: emptyLabel
	});
	return /* @__PURE__ */ jsx("ul", {
		...rest,
		"aria-label": ariaLabel,
		className: cx("ds-change-summary", className),
		children: shown.map((item, index) => {
			const warning = item.tone === "warning";
			return /* @__PURE__ */ jsxs("li", {
				className: cx("ds-change-summary__item", warning && "ds-change-summary__item--warning"),
				children: [warning && /* @__PURE__ */ jsx("span", {
					className: "ds-change-summary__icon",
					children: /* @__PURE__ */ jsx(Icon, {
						name: "alert-triangle",
						label: "Warning"
					})
				}), /* @__PURE__ */ jsxs("span", { children: [item.count !== void 0 && /* @__PURE__ */ jsxs("span", {
					className: "ds-change-summary__count",
					children: [item.count, " "]
				}), item.label] })]
			}, item.key ?? index);
		})
	});
}
/**
* The rows a change affects, under a heading, in a box that scrolls past
* `--diff-list-max-height`. The box is focusable, so the keyboard can scroll it.
*/
function DiffList({ title, children, className, ...rest }) {
	const id = useId();
	return /* @__PURE__ */ jsxs("section", {
		...rest,
		"aria-labelledby": id,
		className: cx("ds-diff-list", className),
		children: [/* @__PURE__ */ jsx("h3", {
			id,
			className: "ds-diff-list__title",
			children: title
		}), /* @__PURE__ */ jsx("ul", {
			className: "ds-diff-list__rows",
			tabIndex: 0,
			"aria-labelledby": id,
			children
		})]
	});
}
/**
* One changed row: the name, then the old value struck through over the new one.
* Screen readers hear "Ana Ruiz, from Harper Kim to Diego Sato", not the strikethrough.
*/
function DiffRow({ name, from, to, fromLabel = "from", toLabel = "to", className, ...rest }) {
	const hasFrom = from !== void 0 && from !== null && from !== "";
	return /* @__PURE__ */ jsxs("li", {
		...rest,
		className: cx("ds-diff-row", className),
		children: [/* @__PURE__ */ jsxs("span", {
			className: "ds-diff-row__name",
			children: [name, /* @__PURE__ */ jsx("span", {
				className: "ds-diff-row__sr",
				children: ", "
			})]
		}), /* @__PURE__ */ jsxs("span", {
			className: "ds-diff-row__values",
			children: [hasFrom && /* @__PURE__ */ jsxs("span", {
				className: "ds-diff-row__from",
				children: [/* @__PURE__ */ jsxs("span", {
					className: "ds-diff-row__sr",
					children: [fromLabel, " "]
				}), /* @__PURE__ */ jsx("s", { children: from })]
			}), /* @__PURE__ */ jsxs("span", {
				className: "ds-diff-row__to",
				children: [/* @__PURE__ */ jsxs("span", {
					className: "ds-diff-row__sr",
					children: [
						" ",
						toLabel,
						" "
					]
				}), to]
			})]
		})]
	});
}
//#endregion
export { ChangeSummary, DiffList, DiffRow };

//# sourceMappingURL=ChangeSummary.js.map